import { api } from '@src/constants/api';
import { createMiddleware, Next } from '@src/utils';
import { enumsActions } from '@src/store/reducers/enumsReducer';

export const createEnumsMiddleware = (http: any) => {
    const restServiceUrl: string = api.restServiceUrl;
    //here will be link
    return createMiddleware({
        [enumsActions.DEPLOY_MODE_TYPES]: async (_: any, next: Next) => {
            try{
                const response = await http.get(`${restServiceUrl}Projects/Enums/DeployModeTypes`);
                const data = response.data;
                next({ type: enumsActions.SET_ENUMS, payload: { DeployModeTypes: data } });
                return data;
            }
           catch{

           }
        },
        [enumsActions.SOURCE_CONTROL_PATH_TYPES]: async (_: any, next: Next) => {
            try{
                const response = await http.get(`${restServiceUrl}Projects/Enums/SourceControlPathTypes`);
                const data = response.data;
                next({ type: enumsActions.SET_ENUMS, payload: { SourceControlPathTypes: data } });
                return response;
            }
            catch{

            }
        },
        [enumsActions.CONFLICT_RESOLVE_ACTION_TYPES]: async (_: any, next: Next) => {
            try{
             const response = await http.get(`${restServiceUrl}Projects/Enums/ConflictResloveActionTypes`);
             const data = response.data;
            next({ type: enumsActions.SET_ENUMS, payload: { ConflictResloveActionTypes: data } });
            return data;
            }
            catch{

            }
        },
        [enumsActions.CONTINUOUS_INTEGRATION_TYPES]: async (_: any, next: Next) => {
            try{
                const response = await http.get(`${restServiceUrl}Projects/Enums/ContinuousIntegrationTypes`);
                const data = response.data;
                next({ type: enumsActions.SET_ENUMS, payload: { ContinuousIntegrationTypes: data } });
                return data;
            }
            catch{

            }  
        },
        [enumsActions.DUPLICATION_ACTION_TYPES]: async (_: any, next: Next) => {
            try{
                const response = await http.get(`${restServiceUrl}Projects/Enums/DuplicationActionTypes`);
                const data = response.data;
                next({ type: enumsActions.SET_ENUMS, payload: { DuplicationActionTypes: data } });
                return data;
            }
           catch{

           }
        },
        [enumsActions.FILE_VERSION_CONTROL_TYPES]: async (_: any, next: Next) => {
            try{
                const response = await http.get(`${restServiceUrl}Projects/Enums/FileVersionControlTypes`);
                const data = response.data;
                next({ type: enumsActions.SET_ENUMS, payload: { FileVersionControlTypes: data } });
                return data;
            }
            catch{

            }
           
        },
        [enumsActions.DB_TYPES]: async (_: any, next: Next) => {
            try{
                const response = await http.get(`${restServiceUrl}Projects/DBTypes`);
                const data = response.data;
                next({ type: enumsActions.SET_ENUMS, payload: { DBTypes: data } });
                return data;
            }
           catch{
            
           }
        }
    });
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/middlewares/enums.middleware.ts